import { render } from "./NovaRegra.vue?vue&type=template&id=fd7b6e0c&scoped=true"
import script from "./NovaRegra.vue?vue&type=script&lang=js"
export * from "./NovaRegra.vue?vue&type=script&lang=js"

import "./NovaRegra.vue?vue&type=style&index=0&id=fd7b6e0c&lang=scss&scoped=true"

import exportComponent from "D:\\Projetos\\Git\\MINUS\\Sites\\site-gerencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd7b6e0c"]])

export default __exports__